import consumer from "./consumer"

const raceId = document.querySelector('meta[name="race-id"]')?.content

if (raceId) {
  consumer.subscriptions.create(
    { channel: "RaceChannel", race_id: raceId },
    {
      connected() {
        console.log(`[RaceChannel] Connected to race ${raceId}`);
      },

      disconnected() {
        console.log("[RaceChannel] Disconnected");
      },

      received(data) {
        console.log("[RaceChannel] Received data:", data);
        
        if (data.type === 'device_config_complete' && data.html) {
          console.log("[RaceChannel] Applying turbo stream...");
          
          // Usar Turbo.renderStreamMessage para procesamiento confiable
          if (typeof Turbo !== "undefined" && typeof Turbo.renderStreamMessage === "function") {
            Turbo.renderStreamMessage(data.html);
            console.log("[RaceChannel] Applied turbo stream successfully");
          } else {
            console.error("[RaceChannel] Turbo.renderStreamMessage not available");
            // Fallback: aplicar manualmente como antes
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = data.html;
            const turboStreams = tempDiv.querySelectorAll('turbo-stream');
            turboStreams.forEach(stream => {
              document.body.appendChild(stream);
            });
            console.log("[RaceChannel] Applied turbo stream via fallback");
          }
        }
      }
    }
  );
} else {
  console.warn("[RaceChannel] No race_id found, skipping subscription");
}
